module.exports = __webpack_public_path__ + "static/media/rim_only.b065ffbe.png";